import { Link, Head, usePage, Deferred } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ColumnDef } from "@tanstack/react-table"
import { FlashMessage } from '@/components/flash-message'
import { SortableHeader } from '@/components/sortable-header'
import { FilteredTable } from '@/components/ui/filtered-table'
import { Team } from '@/types/serializers'


interface Props {
  teams: Team[]
  [key: string]: any
}

const columns: ColumnDef<Team>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => <SortableHeader column={column} title="Name" />,
    enableSorting: true,
    cell: ({ row }) => {
      const team = row.original
      return (
        <Link href={`/teams/${team.id}`} className="hover:underline">
          {team.name}
        </Link>
      )
    }
  },
  {
    accessorKey: "salesforce_id",
    header: "Salesforce ID",
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const team = row.original
      return (
        <div className="flex items-center gap-2">
          <Link href={`/teams/${team.id}`}>
            <Button variant="outline" size="sm">
              View
            </Button>
          </Link>
        </div>
      )
    },
  },
]

export default function Index() {
  const { teams } = usePage<Props>().props

  return (
    <>
      <Head title="Portfolio Teams" />
      <div className="space-y-4 pt-4 px-6">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold">Portfolio Teams</h1>
        </div>
      </div>

      <FlashMessage />

      <div className="p-6">
        <Deferred data="teams" fallback={<div>Loading...</div>}>
          <FilteredTable
            data={teams}
            columns={columns}
            searchPlaceholder="Search teams..."
          />
        </Deferred>
      </div>
    </>
  )
}
